import classNames from 'classnames';
import { RichText } from 'prismic-reactjs';
import React from 'react';
import AboutNav from '../../components/about_nav/about_nav';
import { ContentWrapper } from '../../components/content_wrapper/content_wrapper';
import PrismicSingleLoader from '../../components/prismic_single_loader/prismic_single_loader';
import { ScrollToTop } from '../../components/scroll_to_top/scroll_to_top';
import { SEO } from '../../components/seo/seo';
import { serializeHyperlink } from '../../lib/serializers';
import { linkResolver, PrismicDocumentTypes } from '../../prismic';
import styles from '../../styles/static_pages.less';

export const FaqsPage: React.FC<{}> = (props) => {
  return (
    <ScrollToTop>
      <section>
        <AboutNav />

        <PrismicSingleLoader
          type={PrismicDocumentTypes.FAQS_PAGE}
          render={(page) => {
            return (
              <>
                <SEO title={page.meta_title} description={page.meta_description} />
                <ContentWrapper className={classNames(styles.staticWrapper, styles.aboutContent)}>
                  {page.body.map((slice) => {
                    switch (slice.slice_type) {
                      case 'text': {
                        return (
                          <RichText
                            key={`${slice.primary.text[0].text}:${slice.primary.text.length}`}
                            render={slice.primary.text}
                            linkResolver={linkResolver as any}
                            serializeHyperlink={serializeHyperlink as any}
                          ></RichText>
                        );
                      }
                    }
                  })}
                </ContentWrapper>
              </>
            );
          }}
        ></PrismicSingleLoader>
      </section>
    </ScrollToTop>
  );
};

export default FaqsPage;
